function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-self: center;\n  box-sizing: border-box;\n\n  /* width: 190px; */\n  height: 40px;\n\n  background: #ffffff;\n\n  border: 1px solid ",
        ";\n  border-radius: 6px;\n\n  display: flex;\n  align-items: center;\n\n  :hover {\n    border: 1px solid #46b9ff;\n    color: #46b9ff;\n  }\n\n  user-select: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 8px;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n\n  color: #20242e;\n\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n\n  padding-left: 0.25rem;\n  padding-right: 12px;\n\n  /* color: #20242e; */\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Skeleton from "../Skeleton/Skeleton";
import { StoboxIcon } from "../Svg";
var CurrencyPanel = styled.a.withConfig({
    componentId: "sc-3c2b0726-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var IconContainer = styled.div.withConfig({
    componentId: "sc-3c2b0726-1"
})(_templateObject1());
var TextContainer = styled.div.withConfig({
    componentId: "sc-3c2b0726-2"
})(_templateObject2());
var PriceContaner = styled.div.withConfig({
    componentId: "sc-3c2b0726-3"
})(_templateObject3());
var CakePrice = function(param) {
    var cakePriceUsd = param.cakePriceUsd;
    var stbuPrice = cakePriceUsd !== null && cakePriceUsd !== void 0 ? cakePriceUsd : 0;
    return /*#__PURE__*/ _jsxs(CurrencyPanel, {
        href: "https://coinmarketcap.com/currencies/stobox-token/",
        target: "_blank",
        children: [
            /*#__PURE__*/ _jsx(IconContainer, {
                children: /*#__PURE__*/ _jsx(StoboxIcon, {})
            }),
            /*#__PURE__*/ _jsx(TextContainer, {
                children: "STBU:"
            }),
            stbuPrice > 0 ? /*#__PURE__*/ _jsx(PriceContaner, {
                children: "$".concat(stbuPrice, "\u2197")
            }) : /*#__PURE__*/ _jsx(Skeleton, {
                width: 108,
                height: 20
            })
        ]
    });
};
export default /*#__PURE__*/ React.memo(CakePrice);
